// Lumora API Base URL - centralized configuration
exports.apiBaseUrl = process.env.NEXT_PUBLIC_LUMORA_API_BASE_URL || 'https://dev.api.lumora.capital';

// Default page to redirect users after authentication
exports.defaultPage = process.env.NEXT_PUBLIC_DEFAULT_PAGE || '/agent-management';

// LangFuse project, for deep-linking a usage row to its run in the LangFuse UI. Not a
// secret — it appears in trace URLs. Reading a trace through core-api's proxy does not need
// it; only the external "open in LangFuse" link does, so leaving it unset simply drops that
// link and keeps the in-app view.
exports.langfuseProjectId = process.env.NEXT_PUBLIC_LANGFUSE_PROJECT_ID || '';

// LangFuse UI host. Cloud EU by default; US is https://us.cloud.langfuse.com.
exports.langfuseUiBaseUrl = process.env.NEXT_PUBLIC_LANGFUSE_BASE_URL || 'https://cloud.langfuse.com';
